import { render } from "./resetPasswordComponent.vue?vue&type=template&id=73ef4e9a"
import script from "./resetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./resetPasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__